import { render, staticRenderFns } from "./OptionTargetOtherUserTable.vue?vue&type=template&id=f365e638&lang=pug"
import script from "./OptionTargetOtherUserTable.vue?vue&type=script&lang=ts"
export * from "./OptionTargetOtherUserTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports